const STATUS_ALIASES = {
  waiting: 'pending',
  replied: 'answered',
  in_progress: 'answered',
  resolved: 'answered',
};

export function normalizeSupportTicketStatus(status) {
  const raw = String(status || '').trim().toLowerCase();
  return STATUS_ALIASES[raw] || raw || 'open';
}

export function formatSupportTicketStatus(t, status) {
  const code = normalizeSupportTicketStatus(status);
  const key = `account.support.status_${code}`;
  const label = t(key);
  return label === key ? String(status || code) : label;
}
